var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6378 15.375H0.854478C0.705056 15.3792 0.557254 15.3431 0.426651 15.2704C0.296049 15.1976 0.187485 15.091 0.112404 14.9618C0.037323 14.8325 -0.00149435 14.6854 4.40104e-05 14.5359C0.00158238 14.3864 0.0434194 14.2402 0.121145 14.1125L8.02448 0.41663C8.09762 0.289957 8.20282 0.184768 8.3295 0.111635C8.45618 0.0385015 8.59987 0 8.74615 0C8.89242 0 9.03612 0.0385015 9.16279 0.111635C9.28947 0.184768 9.39467 0.289957 9.46781 0.41663L17.3711 14.1125C17.4489 14.2402 17.4907 14.3864 17.4922 14.5359C17.4938 14.6854 17.455 14.8325 17.3799 14.9618C17.3048 15.091 17.1962 15.1976 17.0656 15.2704C16.935 15.3431 16.7872 15.3792 16.6378 15.375Z",
    fill: "#FAC032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/triangle-warning.f9c07abd49bafee5ef6f7324d58b5efa.svg";
export { ForwardRef as ReactComponent };